function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7454",
    transform: "translate(-1484 -840)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4351",
    width: 46,
    height: 46,
    rx: 10,
    transform: "translate(1484 840)",
    style: {
      fill: "#ebf3f5",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6036"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1022",
    d: "m5460.894 6532.533 2.2 2.221 5.367-5.557",
    transform: "translate(-3958.039 -5668.623)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5867"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3383",
    d: "M116.536-199.663h13.155v1.951h-13.155a1.008 1.008 0 0 0-1.009 1.006v11.192a1.008 1.008 0 0 0 1.009 1.006h13.15a1.008 1.008 0 0 0 1.009-1.006v-11.192a1.008 1.008 0 0 0-1.009-1.006.977.977 0 0 1-.978-.975.977.977 0 0 1 .978-.975 2.96 2.96 0 0 1 2.964 2.957v11.192a2.96 2.96 0 0 1-2.964 2.957h-13.15a2.96 2.96 0 0 1-2.964-2.957v-11.192a2.96 2.96 0 0 1 2.964-2.958z",
    transform: "rotate(90 287.601 1027.842)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Union 36",
    style: {
      fill: "#797e86",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-933 9919.102h-6a1.1 1.1 0 0 1-1.1-1.1v-1a1.1 1.1 0 0 1 1.1-1.1h6a1.1 1.1 0 0 1 1.1 1.1v1a1.1 1.1 0 0 1-1.1 1.1z",
    style: {
      stroke: "none"
    },
    transform: "translate(2442.553 -9063.002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-939 9916.802a.2.2 0 0 0-.2.2v1c0 .11.09.2.2.2h6a.2.2 0 0 0 .2-.2v-1a.2.2 0 0 0-.2-.2h-6m0-1.8h6a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "translate(2442.553 -9063.002)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.4e47ffd7.svg";
export { ForwardRef as ReactComponent };